var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Flex } from 'rebass';
import { media } from '../media';
import styled from '../styled-components';
export var Row = styled(Flex)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex-direction: column;\n  ", "\n"], ["\n  flex-direction: column;\n  ", "\n"])), media.minSm(templateObject_1 || (templateObject_1 = __makeTemplateObject(["flex-direction: row;"], ["flex-direction: row;"]))));
var templateObject_1, templateObject_2;
